import { atom, selectorFamily, atomFamily } from 'recoil';
import { CustomerService } from 'api';
export const customerRequestIdState = atom({
  key: 'customerRequestIdState',
  default: 0
});
export const isOrgNumberValid = atom({
  key: 'isOrgNumberValid',
  default: true
});
const getCustomer = selectorFamily({
  key: 'getCustomer',
  get: customerId => async ({
    get
  }) => {
    get(customerRequestIdState);
    if (!customerId) return null;
    try {
      return await CustomerService.getCustomer({
        customerId
      });
    } catch (e) {
      console.error(e);
    }
    return null;
  }
});
const getCustomerAtom = atomFamily({
  key: 'getCustomerAtom',
  default: customerId => getCustomer(customerId)
});
export default getCustomerAtom;